import React, { useState, useEffect } from   'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { useForm, Controller } from 'react-hook-form';
import { Form, InputGroup, Button, Row, Col, Card, CardHeader, CardBody } from 'react-bootstrap';
import { FaUtensils, FaHome, FaUsers, FaSave, FaEraser, FaDoorOpen } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MenuHogarSSV from './MenuHogarSSV';

export default function InicioEncuesta() {
    const { token, rol, nombre, user } = useAuth();
    const { idEncuesta } = useParams();
    const [Cargando, setCargando] = useState(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [metodosRecoleccion, setMetodosRecoleccion] = useState([]);
    const [proyectoEncuesta, setProyectoEncuesta] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [fichasPersonas, setFichasPersonas] = useState([]);
    const [integrantes, setIntegrantes] = useState([]);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
        idenc_nombre_encuestador: nombre || '',
        idenc_fecha_encuesta: new Date().toISOString().split('T')[0],
        idenc_fecha_digitacion: new Date().toISOString().split('T')[0],
        idenc_metodo_recoleccion: '',
        idenc_metodo_rec_cual: '',
        idenc_ficha_finalizada: null,
        id_user: user,
        id_proyecto: '',
        IdencNombrejh: '',
        municipio: 'MEDELLIN',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
                defaultValues: defaultValues
            }
        );
    const metodoRecoleccion = watch('idenc_metodo_recoleccion') ?? '';
    const idFicha = Number(watch('id')) || 0;
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function BuscarFichasPersona (idPersona) {
        setFichasPersonas([]);
        let url = `/encuestassv/buscarfichasPersona/${idPersona}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            if (result.length === 0) {
                Mensaje('No encontrado', 'No se encontraron fichas para la identificación ingresada.');
            }
            setFichasPersonas(result);

        } catch (error) {
            if (error.response.status === 404) {
                Mensaje('No encontrado', error.response.data.message);
            } else {
                console.error('Error fetching data:', error);
            }
        } finally {
        setCargando(false);
        }
    }
    async function NuevaFicha() {
        reset(defaultValues);
        setMostrarFormulario(true);
    }   
    const resetForm = (data) => {
        reset((prevValues) => ({
            ...prevValues,
            id: data.id.id || '',
            idenc_idficha: data.id.idenc_idficha || '',
            idenc_nombre_encuestador: data.id.idenc_nombre_encuestador || '',
            idenc_fecha_encuesta: data.id.idenc_fecha_encuesta || '',
            idenc_fecha_digitacion: data.id.idenc_fecha_digitacion || '',
            idenc_metodo_recoleccion: data.id?.idenc_metodo_recoleccion?.toString() || '',
            idenc_metodo_rec_cual: data.id?.idenc_metodo_rec_cual || '',
            idenc_ficha_finalizada: data.id?.idenc_ficha_finalizada || null,
            id_user: data.id?.id_user || '',
            id_proyecto: data.id?.id_proyecto?.toString() || '',

            hogarCons: data.hogar?.id ?? '',
            municipio: data.hogar?.municipio ?? 'MEDELLIN',
            ubica_comuna_corregimiento: data.hogar?.ubica_comuna_corregimiento ?? '',
            ubica_nombre_comuna: data.hogar?.ubica_nombre_comuna ?? '',
            ubica_numero_comuna: data.hogar?.ubica_numero_comuna ?? '',
            ubica_barrio_vereda: data.hogar?.ubica_barrio_vereda?.toString() ?? '',
            ubica_nombre: data.hogar?.ubica_nombre ?? '',
            ubica_asentamiento: data.hogar?.ubica_asentamiento?.toString() ?? '',
            ubica_nombre_asentamiento: data.hogar?.ubica_nombre_asentamiento ?? '',
            direccion: data.hogar?.direccion ?? '',
            ubica_numero_apto_int: data.hogar?.ubica_numero_apto_int ?? '',
            ubica_numero_bloque: data.hogar?.ubica_numero_bloque ?? '',
            ubica_nombre_lugar: data.hogar?.ubica_nombre_lugar ?? '',
            ubica_telefono: data.hogar?.ubica_telefono ?? '',
            ubica_otro_telefono: data.hogar?.ubica_otro_telefono ?? '',
            ubica_celular: data.hogar?.ubica_celular ?? '',
            ubica_celular_2: data.hogar?.ubica_celular_2 ?? '',
        }));
    };
    const fetchData = async (idEncuesta) => {
        let url = `/encuestassv/idficha/crearformulariopficha`;
        let obj = { idEncuesta: idEncuesta}
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;        
            setFichasPersonas([]);    
            setMetodosRecoleccion(result.metodosRecoleccion);
            setProyectoEncuesta(result.proyectoEncuesta);
            setComunas(result.comunas);
            setIntegrantes(result.integrantes);
            if(result.id && result.id.id > 0){
                resetForm(result);
                setMostrarFormulario(true);
            } else {
                resetForm(defaultValues);
                setMostrarFormulario(false);
            }
        })
        .catch(error => {
            if (error.response.status === 404) {
                setSwalProps({
                    show: true,
                    title: 'Error',
                    text: error.response.data.message,
                    icon: 'error',
                });
            } else {
                console.error('Error fetching data:', error);
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
  
    useEffect(() => {
        fetchData(idEncuesta);
    }, [idEncuesta]);
    
    async function ConsultarIdFicha(idFicha) {
        navigate(`/encuestassv/id/${idFicha}`);
    }
    async function GuardarFicha() {
        const valid = await trigger(); 
        if (!valid) {
            Mensaje('Validar formulario', 'Por favor complete el formulario correctamente antes de guardar.');
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/idficha/guardarformulariopficha`;
        try {
            setCargando(true);
            const response = await apiService.post(url, datosFormulario, token);
            const result = await response.data;
            Mensaje('Éxito', 'Ficha guardada correctamente.');
            fetchData(result.idFicha);
        } catch (error) {
            if (error.response.status === 422) {
                const respuestalista = error.response.data.errors.map(error => `${error.field}-${error.message}`).join('');
                Mensaje('Guardar persona fallo', `${respuestalista}`);
            } else {
                console.error('Error saving data:', error);
            }
        } finally {
            setCargando(false);
        }
    }
    async function CancelarFicha() {
        resetForm(defaultValues);
        navigate('/encuestassv/id/0');
    }
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <Row className="mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Ficha</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">SSV Ficha</li>
                        </ol>
                    </div>
                    </Row>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                        {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                        </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <Form onSubmit={handleSubmit(GuardarFicha)}>
                        <Card>
                            <CardHeader
                                style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0", cursor: "pointer"}}
                                onClick={() => setMostrarFormulario(!mostrarFormulario)}
                            >   IDENTIFICACION ENCUESTA {idFicha > 0 && ` - FICHA N° ${idFicha}`}
                                <span style={{float: "right"}}>
                                    {mostrarFormulario ? '▼' : '▶'}
                                </span>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                <Col md={5}>
                                    <Form.Group>
                                        <Form.Label>
                                            1. ID Ficha: <span style={{ fontWeight: 'normal' }}>(La identificación de la Ficha es el n&uacute;mero de c&eacute;dula del Jefe de hogar)</span>
                                        </Form.Label>
                                        <InputGroup size="sm">
                                            <Form.Control
                                                id="idenc_idficha"
                                                type="text"
                                                placeholder="La Identificacion de la Ficha es el numero de Cedula del Jefe de Hogar"
                                                {...register('idenc_idficha', { required: true, maxLength: 20 })}
                                            />
                                            <Button
                                                variant="primary"
                                                id="btnIdBuscar"
                                                onClick={() => BuscarFichasPersona(watch('idenc_idficha'))}
                                            >
                                                Buscar
                                            </Button>
                                        </InputGroup>
                                        {errors.idenc_idficha && <span className="text-danger">ID Ficha requerido</span>}
                                    </Form.Group>
                                </Col>
                                </Row>
                                {fichasPersonas.length > 0 && (
                                    <Card className="mt-3">
                                        <CardHeader style={{ backgroundColor: "#f7f7f7", fontSize: "16px", textAlign: "left", padding: "7px 10px", marginTop: "0" }}>
                                            Fichas encontradas
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() => setFichasPersonas([])}
                                                style={{ float: "right" }}
                                            >
                                                Cerrar
                                            </Button>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="table-responsive">
                                                <table className="table table-sm table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: "40px"}}>#</th>
                                                            <th>Identificación</th>
                                                            <th>Nombre</th>
                                                            <th>Id Cabeza</th>
                                                            <th>Fech. encuesta</th>
                                                            <th>Fech. digitación</th>
                                                            <th>Ficha finalizada</th>
                                                            <th style={{width: "120px"}}>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {fichasPersonas.map((f, idx) => {
                                                            const fichaId = f.id ?? '';
                                                            const nombreJh = [
                                                                f.datos_basicos_nombre,
                                                                f.datos_basicos_nombre_2,
                                                                f.datos_basicos_apellido,
                                                                f.datos_basicos_apellido_2
                                                            ].filter(Boolean).join(' ');
                                                            const fechaEncuesta = f.idenc_fecha_encuesta ? new Date(f.idenc_fecha_encuesta).toLocaleDateString() : '';
                                                            const fechaDigitacion = f.idenc_fecha_digitacion ? new Date(f.idenc_fecha_digitacion).toLocaleDateString() : '';
                                                            const finalizada = f.idenc_ficha_finalizada === 1 || f.idenc_ficha_finalizada === '1' || f.idenc_ficha_finalizada === true ? 'Sí' : 'No';
                                                            const idpersona = f.datos_basicos_numero_documento || '';
                                                            const idCabeza = f.idenc_idficha || '';
                                                            const rowKey = `${fichaId || 'ficha'}-${idx}`;
                                                            return (
                                                                <tr key={rowKey}>
                                                                    <td>{fichaId}</td>
                                                                    <td>{idpersona}</td>
                                                                    <td>{nombreJh}</td>
                                                                    <td>{idCabeza}</td>
                                                                    <td>{fechaEncuesta}</td>
                                                                    <td>{fechaDigitacion}</td>
                                                                    <td>{finalizada}</td>
                                                                    <td>
                                                                        <div className="d-flex gap-2">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={() => {
                                                                                    ConsultarIdFicha(fichaId);
                                                                                }}
                                                                            >
                                                                                Abrir
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </CardBody>
                                    </Card>
                                )}
                                {mostrarFormulario && <Card>
                                    <CardHeader style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0"}}>
                                        CONTROL ENCUESTA
                                    </CardHeader>
                                    <CardBody>                                
                                        <Row>
                                            <Col md={2}>
                                                <div className="form-group">
                                                    <label htmlFor='idenc_nombre_encuestador'>1. Encuestador</label>
                                                    <input 
                                                        id="idenc_nombre_encuestador" 
                                                        {...register('idenc_nombre_encuestador', { required: true, maxLength: 100 })}
                                                        type="text" 
                                                        className="form-control" 
                                                        placeholder="Nombre del encuestador"/>
                                                    {errors.idenc_nombre_encuestador && <span className="text-danger">Encuestador requerido</span>}
                                                </div> 
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>2. Fecha encuesta</Form.Label>
                                                    <InputGroup>
                                                        <Controller
                                                            control={control}
                                                            name="idenc_fecha_encuesta"
                                                            rules={{ required: 'Fecha requerida' }}
                                                            render={({ field }) => {
                                                                const selectedDate = field.value ? new Date(field.value) : null;
                                                                return (
                                                                    <DatePicker
                                                                        selected={selectedDate}
                                                                        onChange={date => field.onChange(date ? date.toISOString().split('T')[0] : '')}
                                                                        dateFormat="yyyy-MM-dd"
                                                                        className="form-control"
                                                                        placeholderText="yyyy-mm-dd"
                                                                        wrapperClassName="w-100"
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.idenc_fecha_encuesta && <span className="text-danger">Fecha requerida</span>}
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>3. Fecha digitación</Form.Label>
                                                    <InputGroup>
                                                        <Controller
                                                            control={control}
                                                            name="idenc_fecha_digitacion"
                                                            rules={{ required: 'Fecha requerida'}}
                                                            render={({ field }) => {
                                                                const selectedDate = field.value ? new Date(field.value) : null;
                                                                return (
                                                                    <DatePicker
                                                                        selected={selectedDate}
                                                                        onChange={date => {
                                                                            // store as YYYY-MM-DD string
                                                                            field.onChange(date ? date.toISOString().split('T')[0] : '');
                                                                        }}
                                                                        dateFormat="yyyy-MM-dd"
                                                                        className="form-control"
                                                                        placeholderText="yyyy-mm-dd"
                                                                        wrapperClassName="w-100"
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.idenc_fecha_digitacion && <span className="text-danger">Fecha requerida</span>}
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>4. Método de recolección:</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        {...register('idenc_metodo_recoleccion', { required: true })}
                                                        id="idenc_metodo_recoleccion" 
                                                        onChange={(e) => {
                                                            setValue('idenc_metodo_recoleccion', e.target.value);
                                                            setValue('idenc_metodo_rec_cual', '');
                                                        }}
                                                        style={{width: "100%"}}>
                                                        <>
                                                            <option value=''>Seleccione...</option>
                                                            {metodosRecoleccion.map((m) => (
                                                                <option
                                                                    key={m.id}
                                                                    value={m.id}
                                                                >
                                                                    {m.strmetodo}
                                                                </option>
                                                            ))}
                                                        </>
                                                    </Form.Control>
                                                    {errors.idenc_metodo_recoleccion && <span className="text-danger">Método de recolección requerido</span>}

                                                </Form.Group>
                                            </Col>
                                            {metodoRecoleccion === '3' && <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Especifique otro m&eacute;todo de recolecci&oacute;n</Form.Label>
                                                    <Form.Control
                                                        id="idenc_metodo_rec_cual"
                                                        type="text"
                                                        placeholder="Especifique otro método de recolección"
                                                        {...register('idenc_metodo_rec_cual', { required: (metodoRecoleccion === '3') })}
                                                    />
                                                </Form.Group>
                                                {errors.idenc_metodo_rec_cual && <span className="text-danger">Especifique otro método de recolección</span>}
                                            </Col>}
                                            <Col md={4}>
                                                <Form.Group>
                                                    <Form.Label>5. Codigo proyecto de encuestas</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="id_proyecto"
                                                        {...register('id_proyecto', { required: true })} 
                                                        style={{width: "100%"}} aria-hidden="true">
                                                        <option value='0' ></option>
                                                        {proyectoEncuesta.map((p) => (
                                                            <option key={p.id} value={p.id}>
                                                                {p.str_nombre}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            {errors.id_proyecto && <span className="text-danger">Proyecto de encuestas requerido</span>}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>}
                                {mostrarFormulario && <Card>
                                    <CardHeader style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0"}}>
                                        UBICACIÓN DEL HOGAR EN MEDELL&iacute;N
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>1. Municipio</Form.Label>
                                                    <Form.Control
                                                    readOnly
                                                    type="text"
                                                    placeholder="Municipio"
                                                    {...register('municipio', { required: true, maxLength: 100 })}
                                                    />
                                                    {errors.municipio && <span className="text-danger">Municipio requerido</span>}
                                                </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label htmlFor='ubica_comuna_corregimiento'>2. Comuna o Corregimiento:</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        tabIndex={0} 
                                                        id="ubica_comuna_corregimiento" 
                                                        {...register('ubica_comuna_corregimiento', { required: true })}
                                                        style={{width: "100%"}}>
                                                        <option value=''></option>
                                                        <option value='1' >1. Comuna</option>
                                                        <option value='2'>2. Corregimiento</option>
                                                    </Form.Control>
                                                </Form.Group>
                                                {errors.ubica_comuna_corregimiento && <span className="text-danger">Comuna o Corregimiento requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label htmlFor='ubica_numero_comuna'>3. Nombre de la comuna o corregimiento</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="ubica_numero_comuna"
                                                        {...register('ubica_numero_comuna', { required: true })}
                                                        style={{width: "100%"}}
                                                        onClick={(e) => {
                                                            setValue('ubica_numero_comuna', e.target.value);
                                                        }}>
                                                        <option value=''></option>
                                                        {comunas.map((comuna) => (
                                                            <option key={comuna.idcomuna} value={comuna.idcomuna}>{comuna.comuna}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                                {errors.ubica_numero_comuna && <span className="text-danger">Nombre de la comuna o corregimiento requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>Numero de la comuna o corregimiento</Form.Label>
                                                    <Form.Control
                                                        readOnly
                                                        id="ubica_numero_comuna"
                                                        type="text"
                                                        {...register('ubica_numero_comuna', { required: true, maxLength: 3 })}
                                                        placeholder="Numero de la comuna o corregimiento"
                                                    />
                                                </Form.Group>
                                                {errors.ubica_numero_comuna && <span className="text-danger">Número de la comuna o corregimiento requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>4. Barrio o Vereda </Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="slcubicaBarrioVereda" 
                                                        style={{width: "100%"}} 
                                                        {...register('ubica_barrio_vereda', { required: true })}>
                                                    <option value=''></option>
                                                    <option value='1' >1. Barrio</option>
                                                    <option value='2'>2. Vereda</option>
                                                    </Form.Control>
                                                </Form.Group>
                                            {errors.ubica_barrio_vereda && <span className="text-danger">Barrio o Vereda requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>5. Nombre del barrio o la vereda</Form.Label>
                                                    <Form.Control
                                                        id="txtubicaNombre"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Nombre del barrio o la vereda"
                                                        {...register('ubica_nombre', { required: true })}
                                                    />
                                                </Form.Group>
                                                {errors.ubica_nombre && <span className="text-danger">Nombre del barrio o la vereda requerido</span>}
                                            </Col>
                                                <Col md={2}>
                                                <Form.Group>
                                                    <Form.Label>6. ¿El Hogar vive o se ubica en un asentamiento?</Form.Label>
                                                    <Form.Control 
                                                        as="select" 
                                                        id="ubica_asentamiento" 
                                                        style={{width: "100%"}}
                                                        {...register('ubica_asentamiento', { required: true })}
                                                        onChange={(e) => {
                                                            setValue('ubica_asentamiento', e.target.value);
                                                            if (e.target.value === '2') {
                                                                setValue('ubica_nombre_asentamiento', '');
                                                            }
                                                        }}>
                                                        <option value=''></option>
                                                        <option value='1'>1. Si</option>
                                                        <option value='2'>2. No</option>
                                                    </Form.Control>
                                                </Form.Group>
                                                {errors.ubica_asentamiento && <span className="text-danger">El campo es requerido</span>}
                                            </Col>
                                            {watch('ubica_asentamiento') == '1' && (
                                                <Col md={2}>
                                                    <Form.Group>
                                                        <Form.Label>7. Nombre del asentamiento</Form.Label>
                                                        <Form.Control  
                                                            id="ubica_nombre_asentamiento" 
                                                            type="text" 
                                                        className="form-control" 
                                                        placeholder="Nombre del asentamiento"
                                                        {...register('ubica_nombre_asentamiento')}/>
                                                </Form.Group>
                                                {errors.ubica_nombre_asentamiento && <span className="text-danger">Nombre del asentamiento requerido</span>}
                                            </Col>)}
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                            <Form.Group>
                                                <Form.Label>8. Dirección o nombre del predio</Form.Label>
                                                <Form.Control 
                                                    id="direccion" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Dirección o nombre del predio"
                                                    {...register('direccion', { required: true })}/>  
                                            </Form.Group>
                                            {errors.direccion && <span className="text-danger">Dirección o nombre del predio requerido</span>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>9. Numero de la casa o del apartamento o interior</Form.Label>
                                                <Form.Control 
                                                    id="ubica_numero_apto_int" 
                                                    type="text" 
                                                    className="form-control"
                                                    {...register('ubica_numero_apto_int')}/>
                                            </Form.Group>
                                            {errors.ubica_numero_apto_int && <span className="text-danger">Número de la casa o del apartamento o interior requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>10. Numero de bloque o torre (No aplica si es casa)</Form.Label>
                                                <Form.Control 
                                                    id="ubica_numero_bloque" 
                                                    type="text" 
                                                    className="form-control"
                                                    {...register('ubica_numero_bloque')}/>  
                                            </Form.Group>
                                            {errors.ubica_numero_bloque && <span className="text-danger">Número de bloque o torre requerido</span>}
                                            </Col>
                                            <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>11. Nombre de la urbanización</Form.Label>  
                                                <Form.Control 
                                                    id="ubica_nombre_lugar" 
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('ubica_nombre_lugar')}/>
                                            </Form.Group>
                                            {errors.ubica_nombre_lugar && <span className="text-danger">Nombre de la urbanización requerido</span>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>12. Telefóno fijo</Form.Label>
                                                <Form.Control 
                                                    id="ubica_telefono" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Telefóno fijo 1" 
                                                    {...register('ubica_telefono')}/>
                                                    {errors.ubica_telefono && <span className="text-danger">Teléfono fijo 1 requerido</span>}
                                                <Form.Control 
                                                    id="ubica_otro_telefono" 
                                                    type="text"
                                                    className="form-control" 
                                                    placeholder="Telefóno fijo 2" 
                                                    {...register('ubica_otro_telefono')}/>
                                                    {errors.ubica_otro_telefono && <span className="text-danger">Teléfono fijo 2 requerido</span>}
                                            </Form.Group>
                                            </Col>
                                            <Col md={2}>
                                            <Form.Group>
                                                <Form.Label>13. Teléfono celular</Form.Label>
                                                <Form.Control 
                                                    id="ubica_celular" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Número celular 1" 
                                                    {...register('ubica_celular')}/>    
                                                    {errors.ubica_celular && <span className="text-danger">Número celular 1 requerido</span>}                                            
                                                <Form.Control 
                                                    id="ubica_celular_2" 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Número celular 2" 
                                                    {...register('ubica_celular_2')}/>
                                                    {errors.ubica_celular_2 && <span className="text-danger">Número celular 2 requerido</span>}
                                            </Form.Group>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>}
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {idFicha === 0 && <Col md={2}>
                                                <Button 
                                                    type="button" 
                                                    className="btn btn-block btn-primary btn-sm"
                                                    id="btnIdNuevo"
                                                    onClick={() => NuevaFicha()}>
                                                        Nuevo
                                                    </Button>
                                            </Col>}
                                            {mostrarFormulario && <Col id="colidguardar" md={2}>
                                                <Button 
                                                    type="button" 
                                                    className="btn btn-block btn-primary btn-sm" 
                                                    onClick={() => GuardarFicha()}
                                                    id="btnIdGuardar"><FaSave style={{ marginRight: '12px', fontSize: '1.4rem' }} />Guardar</Button>  
                                            </Col>}
                                            {rol === '2' && idFicha > 0 && <Col id="colidborrar" md={2}>
                                            <Button 
                                                type="button" 
                                                className="btn btn-block btn-primary btn-sm" 
                                                id="btnIdBorrar" >
                                                <FaEraser style={{ marginRight: '12px', fontSize: '1.4rem' }} />Borrar ficha
                                            </Button>
                                            </Col>}
                                            {idFicha > 0 && <Col id="colidcancelar" md={2}>
                                            <Button 
                                                type="button" 
                                                className="btn btn-block btn-primary btn-sm" 
                                                id="btnIdcancelar"
                                                onClick={() => CancelarFicha()}
                                                >
                                                    <FaDoorOpen style={{ marginRight: '12px', fontSize: '1.4rem' }} />
                                                    Salir de ficha
                                                </Button> 
                                            </Col>}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </CardBody>
                        </Card>
                    </Form>
                    {idFicha > 0 && <Card>
                        <CardHeader style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0"}}>
                            CONTINUAR CON REGISTRO DE LA FICHA
                        </CardHeader>
                    </Card>}
                    {idFicha > 0 && <Card>
                        <CardHeader style={{backgroundColor:"#f7f7f7", fontSize: "18px", textAlign: "center", padding: "7px 10px", marginTop: "0"}}>
                            LISTA DE INTEGRANTES DE LA FAMILIA
                        </CardHeader>
                        <CardBody>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th style={{width: "40px"}}>#</th>
                                            <th style={{width: "40px"}}># Ficha</th>
                                            <th>1. Primer nombre</th>
                                            <th>1. Segundo nombre</th>
                                            <th>1. Primer apellido</th>
                                            <th>1. Segundo apellido</th>
                                            <th>2. ¿Qué tipo de documento de identificación tiene...?</th>
                                            <th>3. Número de documento de identificación</th>
                                            <th>4. ¿...cuenta con el documento de identificación?</th>
                                            <th>5. ¿Corresponde el documento de identificación con la edad?</th>
                                            <th>6. ¿El documento de identeidad esta legible?</th>
                                            <th>7. ¿Cuál es la fecha de nacimiento de...?</th>
                                            <th>7.a. Edad Calculada</th>
                                            <th>8. Edad</th>
                                            <th>9. El parentesco de … con la persona jefe del hogar es:</th>
                                            <th>10. Estado civil</th>
                                            <th>11. ¿...Tiene libreta militar?</th>
                                            <th>12. ¿Estado RUV?</th>
                                            <th>13. Tiene SISBEN en Medellin</th>
                                            <th>Observaciones</th>
                                            <th>15. Sexo</th>
                                            <th>16. ¿Algún miembro del hogar tiene condicion de genero diversa? (OSIEGD)</th>
                                            <th>17. De acuerdo con su cultura, pueblo o rasgos físicos, ... se reconoce como:</th>
                                            <th>18a. Discapacidad: Fisica miembros Superiores</th>
                                            <th>18b. Discapacidad: Fisica miembros Inferiores</th>
                                            <th>18c. Discapacidad: Sensorial Visual</th>
                                            <th>18d. Discapacidad: Sensorial Auditiva</th>
                                            <th>18e. Discapacidad: Psiquica</th>
                                            <th>18f. Discapacidad: Intelectual</th>
                                            <th>18g. Discapacidad: Enfermedad Crónica o Terminal</th>
                                            <th>18h. Discapacidad: Ninguna</th>
                                            <th>19. La discapacidad que tiene el miembro del Hogar es una consecuencia del conflicto armado</th>
                                            <th>20. Alguna mujer del grupo familiar esta?</th>
                                            <th>21. Fecha en la que comenzó a gestar?</th>
                                            <th>22. Fecha en la que comenzó a lactar?</th>
                                            <th>Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {integrantes.map((integrante, idx) => {
                                            return (
                                                <tr key={integrante.id || idx}>
                                                    <td>
                                                        <NavLink 
                                                            to={`/encuestassv/datosbasicos/${integrante.id}/${idEncuesta}`}
                                                            className="btn btn-sm btn-primary">
                                                            Ver
                                                        </NavLink>
                                                    </td>
                                                    <td>{integrante.id}</td>
                                                    <td>{integrante.cons_ficha_id}</td>
                                                    <td>{integrante.datos_basicos_nombre}</td>
                                                    <td>{integrante.datos_basicos_nombre_2}</td>
                                                    <td>{integrante.datos_basicos_apellido}</td>
                                                    <td>{integrante.datos_basicos_apellido_2}</td>
                                                    <td>{integrante.datos_basicos_tipo_documento}</td>
                                                    <td>{integrante.datos_basicos_numero_documento}</td>
                                                    <td>{integrante.datos_basicos_cuenta_con_documento}</td>
                                                    <td>{integrante.datos_basicos_documento_corresponde_con_edad}</td>
                                                    <td>{integrante.datos_basicos_documento_legible}</td>
                                                    <td>{integrante.datos_basicos_fecha_nacimiento}</td>
                                                    <td>{integrante.edad_calculada}</td>
                                                    <td>{integrante.datos_diferenciales_edad}</td>
                                                    <td>{integrante.datos_basicos_parentesco}</td>
                                                    <td>{integrante.datos_basicos_estado_civil}</td>
                                                    <td>{integrante.datos_basicos_libreta_militar}</td>
                                                    <td>{integrante.datos_basicos_estado_ruv}</td>
                                                    <td>{integrante.datos_basicos_sisben}</td>
                                                    <td>{integrante.datos_basicos_observacion}</td>
                                                    <td>{integrante.datos_diferenciales_sexo}</td>
                                                    <td>{integrante.datos_diferenciales_lgbti}</td>
                                                    <td>{integrante.datos_diferenciales_etnia}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad1}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad2}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad3}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad4}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad5}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad6}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad7_terminal}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad8}</td>
                                                    <td>{integrante.datos_diferenciales_discapacidad_consecuencia_hecho_victimizant}</td>
                                                    <td>{integrante.datos_diferenciales_mujer_gestante_lactante}</td>
                                                    <td>{integrante.datos_diferenciales_fecha_gestancia}</td>
                                                    <td>{integrante.datos_diferenciales_fecha_lactancia}</td>
                                                    <td>
                                                        <NavLink 
                                                            to={`/encuestassv/datosbasicos/${integrante.id}/${idEncuesta}`}
                                                            className="btn btn-sm btn-primary">
                                                            Ver
                                                        </NavLink>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <NavLink 
                                to={`/encuestassv/datosbasicos/0/${idEncuesta}`}
                                className="btn btn-sm btn-primary">
                                Agregar nuevo integrante
                            </NavLink>
                        </CardBody>
                    </Card>}
                    {idFicha > 0 && <MenuHogarSSV idEncuesta={idEncuesta} />}
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>            
        </div>
      
  )
  }